import React, { memo, useState } from 'react';
import { UploadFile } from 'antd/es/upload/interface';
import { Input, Modal, Upload, message } from 'antd';
import { UploadChangeParam, UploadProps } from 'antd/lib/upload';
import { RiAddLine } from 'react-icons/ri';
import { ImageDescUploadListStyle } from './style';
import ImgPreviewItem from './imgPreviewItem';
import { isFileOversized, isMusic } from 'utils/functions/file';

type Props = {
  disabled?: boolean
  value?: UploadFile[]
  onChange?: (params: UploadFile[]) => void
  maxLength?: number
} & UploadProps
const MusicUploadList: React.FC<Props> = memo(({ onChange: onFileChange, ...props }) => {
  const [previewImage, setPreviewImage] = useState('');
  const [messageApi, contextHolder] = message.useMessage();
  const fileList = props.value || [];


  const onChange = async ({ fileList }: UploadChangeParam) => {
    let innerError = 0
    for (let i = 0; i < fileList.length; i++) {
      const file = fileList[i].originFileObj;
      if (file && !isMusic(file)) {
        innerError = 1
        break
      }
      if (file && isFileOversized(file, 20)) {
        innerError = 2
        break
      }
    }

    switch (innerError) {
      case 1:
        messageApi.warning('上传文件中包含不支持的音频格式,请检查后重新上传', 2);
        break;
      case 2:
        messageApi.warning('上传文件中包含尺寸超出20M文件,请检查后重新上传', 2);
        break;
    }

    if (innerError === 0) {
      onFileChange!(fileList);
    }

  };

  const onRemove = (file: UploadFile) => {
    if (props.disabled) {
      return false
    }
    const newFileList = fileList.filter(
      (item) => item.uid !== file.uid
    );

    onFileChange!(newFileList);

  };
  const beforeUpload = () => {

    return false
  }
  const uploadButton = (
    <div>
      <RiAddLine />
      <div>上传</div>
    </div>
  );

  return (
    <ImageDescUploadListStyle>
      {contextHolder}
      {fileList && (
        <div className='drop-wrap'>
          {fileList.map((item, index) => (
            <div className='drop' key={index}>
              <ImgPreviewItem item={item} onDelete={onRemove}></ImgPreviewItem>
            </div>
          ))}

          {!props.disabled && fileList.length < 8 && <Upload
            {...props}
            disabled={props.disabled}
            fileList={fileList}
            showUploadList={false}
            beforeUpload={beforeUpload}
            onChange={onChange}
            multiple={true}
            className="upload-add"
          >
            {uploadButton}
          </Upload>
          }
        </div>

      )}
      <Modal
        open={!!previewImage}
        footer={null}
        onCancel={() => setPreviewImage('')}
        bodyStyle={{ padding: 0 }}
      >
        <img style={{ width: '100%' }} alt="" src={previewImage} />
      </Modal>
    </ImageDescUploadListStyle>
  );
});

export default MusicUploadList;
